import React from 'react';
import classNames from 'classnames';
import styles from './Table.module.scss';

interface TableProps {
  children: React.ReactNode;
  className?: string;
}

export function Table({children, className}: TableProps) {
  return <div className={classNames(styles.table, className)}>{children}</div>;
}

export default Table;
